import { render, staticRenderFns } from "./TableConfigurarRegalados.vue?vue&type=template&id=38fbba60&scoped=true"
import script from "./TableConfigurarRegalados.vue?vue&type=script&lang=js"
export * from "./TableConfigurarRegalados.vue?vue&type=script&lang=js"
import style0 from "./TableConfigurarRegalados.vue?vue&type=style&index=0&id=38fbba60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbba60",
  null
  
)

export default component.exports